import cx from "classnames";
import { get } from "lodash";
import { RichText } from "prismic-reactjs";
import { styled } from "styled-components";
import Link from "../../components/Link";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";

const StlWrapper = styled.section`
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  display: grid;
  grid-template-columns: 132px auto;
  padding: 10px 20px 10px 10px;
  gap: 40px;
`;

const StlImageWrapper = styled.div`
  width: 131px;
  height: 124px;
  border-radius: 6px;
  overflow: hidden;
`;

const StlContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;

const StlLink = styled(Link)`
  align-self: flex-start;
`;

const StoreCard = ({ src, alt, copy, link, className, key }) => {
  return (
    <StlWrapper className={className} key={key}>
      <StlImageWrapper>
        <LazyLoadImage
          className="cover-img"
          wrapperClassName="stretch"
          src={src}
          alt={alt}
          effect="opacity"
        />
      </StlImageWrapper>
      <StlContentWrapper
        data-state="Illinois"
        data-store={get(copy, "[0].text")}
      >
        <RichText render={copy} />
        <StlLink
          url={link}
          text="Shop Now"
          ariaLabel={"Shop Now at " + get(copy, "[0].text")}
          dataStore={get(copy, "[0].text")}
          className="store-card-btn"
          target="_blank"
        >
          Shop Now
        </StlLink>
      </StlContentWrapper>
    </StlWrapper>
  );
};

export default StoreCard;
